module.exports = __webpack_public_path__ + "img/climate_actions_ebike.cf1a672.webp";